module.exports = __webpack_public_path__ + "img/rmgz.a1072de.png";